<template>
  <img
    :src="require('@/assets/img/' + color + 'logo.svg')"
    alt="Repay"
    @click="$router.go('/events')"
  >
</template>

<script>
export default {
  name: 'Logo',
  props: {
    color: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  cursor: pointer;
}
</style>
